import styled from 'styled-components'

export const CloseDealModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`
